import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { StyledLink } from '../../styles/Components/Common'

const Quote = styled.p`
  margin: 8px 0 0 0;
  font-size: 0.75rem;
  text-align: center;
  color: ${props => props.theme.common.colors.darkGray};

  &.highlight {
    color: ${props => props.theme.common.colors.tangerine};
    font-size: 1.1rem;
  }
`

const Description = styled(Quote)`
  margin: 0 0 4px 0;
  font-size: 1.25rem;

  &.highlight {
    color: ${props => props.theme.common.colors.darkGray};
    font-size: 1.75rem;
  }
`

const Centered = styled.div`
  position: relative;
  top: 50px;
  @media screen and (max-width: ${props => props.theme.mobilebreakpoint}px) {
    top: 20px;
  }
`

const VBox = styled.div`
  display: flex;
  flex-direction: column;
`

const DescriptionLink = styled(StyledLink)`
  &, &:hover, &:active, &:visited { color: ${props => props.theme.common.colors.darkGray}; }
`

class EmptyState extends PureComponent {
  render () {
    const { quote, highlight, description, viewBox, height, linkto } = this.props
    return (
      <Centered>
        <VBox>
          <svg
            id='Layer_1'
            data-name='Layer 1'
            viewBox={viewBox}
            height={height}
          >
            <title>There is no data available.</title>
            <ellipse
              cx='150'
              cy='137.74'
              style={{ fill: '#f3f6fe' }}
              rx='25.41'
              ry='7.85'
              transform='translate(-51.42 107.66) rotate(-34.07)'
            />
            <path
              d='M133.2,57.37H114.55a8.18,8.18,0,0,1,0-3.49h4.12a2,2,0,0,0,2-2v-.58a2,2,0,0,0-2-2H101.23a2,2,0,0,0-2,2v.58a2,2,0,0,0,2,2h7.87a7.13,7.13,0,0,1,.09,3.49H103a2,2,0,0,0-2,2V60a2,2,0,0,0,2,2h4.65a5.44,5.44,0,0,1,.12,3.49H93.09a2,2,0,0,0-2,2v.58a2,2,0,0,0,2,2h27.32a2,2,0,0,0,2-2v-.58a2,2,0,0,0-2-2H115A6.23,6.23,0,0,1,115,62H133.2a2,2,0,0,0,2-2V59.4A2,2,0,0,0,133.2,57.37Z'
              style={{ fill: '#f3f6fe' }}
            />
            <path
              d='M236.23,128.39H213a10.53,10.53,0,0,1,0-4.35h5.13a2.54,2.54,0,0,0,2.54-2.53v-.73a2.54,2.54,0,0,0-2.54-2.53H196.36a2.54,2.54,0,0,0-2.54,2.53v.73a2.54,2.54,0,0,0,2.54,2.53h9.81a8.93,8.93,0,0,1,.12,4.35h-7.76a2.55,2.55,0,0,0-2.54,2.54v.73a2.54,2.54,0,0,0,2.54,2.53h5.79a6.71,6.71,0,0,1,.16,4.35H186.21a2.55,2.55,0,0,0-2.54,2.54v.73a2.54,2.54,0,0,0,2.54,2.53h34.07a2.55,2.55,0,0,0,2.54-2.53v-.73a2.56,2.56,0,0,0-2.54-2.54h-6.74a7.66,7.66,0,0,1,0-4.35h22.68a2.55,2.55,0,0,0,2.54-2.53v-.73A2.56,2.56,0,0,0,236.23,128.39Z'
              style={{ fill: '#f3f6fe' }}
            />
            <path
              d='M81.72,141.26H97.9a7.48,7.48,0,0,0,0-3H94.32a1.76,1.76,0,0,1-1.76-1.76V136a1.76,1.76,0,0,1,1.76-1.77h15.12a1.77,1.77,0,0,1,1.77,1.77v.5a1.77,1.77,0,0,1-1.77,1.76h-6.82a6.24,6.24,0,0,0-.08,3h5.39A1.77,1.77,0,0,1,109.7,143v.51a1.77,1.77,0,0,1-1.77,1.76h-4a4.68,4.68,0,0,0-.1,3h12.7a1.77,1.77,0,0,1,1.76,1.77v.5a1.77,1.77,0,0,1-1.76,1.77H92.81a1.77,1.77,0,0,1-1.76-1.77v-.5a1.77,1.77,0,0,1,1.76-1.77H97.5a5.41,5.41,0,0,0,0-3H81.72A1.76,1.76,0,0,1,80,143.53V143A1.76,1.76,0,0,1,81.72,141.26Z'
              style={{ fill: '#f3f6fe' }}
            />
            <g style={{ opacity: 0.85 }}>
              <path
                d='M73.89,115.37a14.8,14.8,0,0,1,.66,2.47c.16.82.28,1.66.36,2.49S75,122,75,122.85a14.57,14.57,0,0,1-.2,2.54,14.47,14.47,0,0,1-.67-2.46,26.44,26.44,0,0,1-.46-5A14.69,14.69,0,0,1,73.89,115.37Z'
                style={{ fill: '#65bed9' }}
              />
              <path
                d='M79.36,119.89a15.51,15.51,0,0,1-2.46.68c-.83.16-1.66.29-2.49.37s-1.67.12-2.52.12a13.63,13.63,0,0,1-2.54-.18,13.64,13.64,0,0,1,2.46-.68,23,23,0,0,1,2.49-.37,23.36,23.36,0,0,1,2.52-.13A14.56,14.56,0,0,1,79.36,119.89Z'
                style={{ fill: '#65bed9' }}
              />
              <rect
                width='3.95'
                height='3.95'
                x='72.38'
                y='118.41'
                style={{ fill: '#65bed9' }}
                rx='1.31'
                ry='1.31'
                transform='translate(-65.77 100.72) rotate(-50.31)'
              />
            </g>
            <g style={{ opacity: 0.85 }}>
              <path
                d='M151.84,51.94a14.75,14.75,0,0,1,.7,2.45q.26,1.24.39,2.49a23.66,23.66,0,0,1,.15,2.52,14.68,14.68,0,0,1-.16,2.55,15.63,15.63,0,0,1-.71-2.46q-.26-1.23-.39-2.49c-.09-.83-.14-1.67-.15-2.51A15.76,15.76,0,0,1,151.84,51.94Z'
                style={{ fill: '#65bed9' }}
              />
              <path
                d='M157.38,56.37a14.84,14.84,0,0,1-2.45.72c-.83.18-1.66.31-2.49.41a23.33,23.33,0,0,1-2.51.16,13.7,13.7,0,0,1-2.55-.15,14.26,14.26,0,0,1,2.45-.71,23.31,23.31,0,0,1,2.48-.41,23.68,23.68,0,0,1,2.52-.16A14.65,14.65,0,0,1,157.38,56.37Z'
                style={{ fill: '#65bed9' }}
              />
              <rect
                width='3.95'
                height='3.95'
                x='150.4'
                y='54.97'
                style={{ fill: '#65bed9' }}
                rx='1.31'
                ry='1.31'
                transform='translate(12.5 139.98) rotate(-51.18)'
              />
            </g>
            <g style={{ opacity: 0.85 }}>
              <path
                d='M184.84,151.94a14.75,14.75,0,0,1,.7,2.45q.26,1.25.39,2.49a23.66,23.66,0,0,1,.15,2.52,14.68,14.68,0,0,1-.16,2.55,15.63,15.63,0,0,1-.71-2.46q-.26-1.23-.39-2.49c-.09-.83-.14-1.67-.15-2.51A15.76,15.76,0,0,1,184.84,151.94Z'
                style={{ fill: '#65bed9' }}
              />
              <path
                d='M190.38,156.37a14.84,14.84,0,0,1-2.45.72c-.83.18-1.66.31-2.49.41a23.33,23.33,0,0,1-2.51.16,13.7,13.7,0,0,1-2.55-.15,14.26,14.26,0,0,1,2.45-.71,23.31,23.31,0,0,1,2.48-.41,23.68,23.68,0,0,1,2.52-.16A14.65,14.65,0,0,1,190.38,156.37Z'
                style={{ fill: '#65bed9' }}
              />
              <rect
                width='3.95'
                height='3.95'
                x='183.4'
                y='154.97'
                style={{ fill: '#65bed9' }}
                rx='1.31'
                ry='1.31'
                transform='translate(-53.1 203.01) rotate(-51.18)'
              />
            </g>
            <circle
              cx='171.59'
              cy='157.03'
              r='2.62'
              style={{ opacity: 0.85, fill: '#fbb03b' }}
            />
            <circle
              cx='207.04'
              cy='104.75'
              r='2.62'
              style={{ opacity: 0.85, fill: '#fbb03b' }}
            />
            <circle
              cx='76.24'
              cy='79.02'
              r='2.62'
              style={{ opacity: 0.85, fill: '#fbb03b' }}
            />
            <circle
              cx='169.31'
              cy='65.46'
              r='1.93'
              style={{ fill: '#3930aa' }}
            />
            <g style={{ opacity: 0.9 }}>
              <path
                d='M150,75c-6.3-4.53-15.54-4.15-22.25-1.54s-13,8.11-14.59,15.65a17.59,17.59,0,0,0,9.42,18.67c4.51,2.3,9.68,1,14.26-.54a88.27,88.27,0,0,0,11.27-4.51c1.63-.78,4.08-1.59,5.4-2.84a11,11,0,0,0,2.36-3.82C158.28,88.76,156.54,79.67,150,75Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M177.67,113a16.31,16.31,0,0,1-.63,2.59c-.17.52-.36,1-.58,1.53a18.16,18.16,0,0,1-3.05,4.78c-.37.42-.76.82-1.16,1.2a17,17,0,0,1-4.15,2.9,16.88,16.88,0,0,0,.22-5.68,14.3,14.3,0,0,0,1.33-1.14c.23-.22.47-.46.69-.7s.63-.72.93-1.1a16.92,16.92,0,0,0,1.43-2.2c.19-.35.37-.72.53-1.09a6.57,6.57,0,0,0,.26-.61,7.13,7.13,0,0,1,1.26-2.43,1.87,1.87,0,0,1,2.48-.32A2.5,2.5,0,0,1,177.67,113Z'
                style={{ fill: '#fffefd' }}
              />
              <path
                d='M168.32,120.32a16.88,16.88,0,0,1-.22,5.68,13.38,13.38,0,0,1-2.17,4.88q-.24.33-.51.66a18.35,18.35,0,0,1-3.65,3.39,23.56,23.56,0,0,1-2.2,1.35c-.69.36-1.4.69-2.12,1-.44.18-.88.35-1.33.5-4.11,1.36-7.72,3.34-12.13,3.79a21.21,21.21,0,0,1-4.14,0,19.22,19.22,0,0,1-3.45-.63l-.75-.23a12.09,12.09,0,0,1-6.42-5.15,30.82,30.82,0,0,1-2.5-4.39,40.59,40.59,0,0,1-2.4-6.6,45.79,45.79,0,0,1-1.48-9h0c0-.27,0-.54,0-.81-.12-2.87.18-5.92-.47-8.75,0-.16-.08-.32-.13-.48a20,20,0,0,0-1.58-3.55,18.26,18.26,0,0,1-1.37-3.11c-.94-3.08-.75-6.27-1.09-9.43a11.75,11.75,0,0,1,.11-2.3c0-.52,0-1.11.09-1.62a.64.64,0,0,1,.22-.38c.34-.26.75,0,1,.24a51.86,51.86,0,0,1,4.44,4.2.75.75,0,0,0,1,.09,32.34,32.34,0,0,1,4-2.52c.47-.25,1-.5,1.44-.73A34,34,0,0,1,143,83.15a.76.76,0,0,0,.71-.63,26.73,26.73,0,0,0,.43-4.72c0-.54-.21-2.47.91-2.13a1.06,1.06,0,0,1,.51.32,46,46,0,0,1,6.8,9.61,16.8,16.8,0,0,1,1.05,2.54h0c.81,2.47,1.2,5,2.23,7.4a10.79,10.79,0,0,0,.77,1.47h0a45,45,0,0,0,3.73,4.77c.35.43.69.87,1,1.32.45.64.87,1.31,1.28,2,.76,1.26,1.45,2.58,2.1,3.91.51,1,1,2.11,1.44,3.15l.22.54A28.75,28.75,0,0,1,168.32,120.32Z'
                style={{ fill: '#fffefd' }}
              />
              <path
                d='M132.34,92.38a1.94,1.94,0,0,1,.49,1.31c-.1,2.14-2.8,2.64-2.23,5.24a1.81,1.81,0,0,1,.05,1.29c-.26.46-.89.5-1.41.48l-2.69-.08a6.26,6.26,0,0,1-2.24-.35,2.81,2.81,0,0,1-1.43-4c.33-.75.81-1.43,1.21-2.16a8.83,8.83,0,0,1,1.18-1.93A4.29,4.29,0,0,1,128,91a5.7,5.7,0,0,1,3.9,1A3.42,3.42,0,0,1,132.34,92.38Z'
                style={{ fill: '#edeff4' }}
              />
              <path
                d='M153.44,88.14a10.17,10.17,0,0,1-3.93,6.65c-1.34,1-2.83.74-4.3.18a23.06,23.06,0,0,0-3-1.1,4.29,4.29,0,0,0-4,1c-.86.77-2,1.54-3.07,1.18a2.71,2.71,0,0,1-1.53-1.82c-.26-.78-.35-1.61-.66-2.36-.71-1.69-2.53-1.64-3.56-2.9a2.14,2.14,0,0,1-.33-1.86,34,34,0,0,1,13.95-4,.76.76,0,0,0,.71-.63,26.73,26.73,0,0,0,.43-4.72c0-.54-.21-2.47.91-2.13a1.06,1.06,0,0,1,.51.32,46,46,0,0,1,6.8,9.61A16.8,16.8,0,0,1,153.44,88.14Z'
                style={{ fill: '#edeff4' }}
              />
              <path
                d='M162.46,105.09a8.08,8.08,0,0,0-1,1.08,5.05,5.05,0,0,0-.49,2.19,2.16,2.16,0,0,1-1.11,1.86.66.66,0,0,1-.2.06c-.89.18-1.75-.63-2.29-1.41s-1-1.54-1.89-1.75-1.68.37-2.59-.15l-.06,0c-1.14-.7-.74-1.83-.44-3,.43-1.63.1-3.67.7-5.17a3.2,3.2,0,0,1,3.38-1.8h0c1.34,2.21,3.26,4,4.74,6.09C161.63,103.74,162.05,104.41,162.46,105.09Z'
                style={{ fill: '#edeff4' }}
              />
              <path
                d='M139.85,141.58a18.77,18.77,0,0,1-4.2-.86,12.09,12.09,0,0,1-6.42-5.15c-4-5.86-6.12-13.79-6.43-20.85-.12-2.87.18-5.92-.47-8.75,0-.16-.08-.32-.13-.48a6.73,6.73,0,0,1,5.17,1.14c1.33,1.19,1.09,3.25.2,4.6-.48.73-1.07,1.39-1.48,2.17a6.93,6.93,0,0,0-.41,4.71,20.3,20.3,0,0,0,1.82,4.46.08.08,0,0,1,0,.05,14.84,14.84,0,0,0,3.06,4.53,40.72,40.72,0,0,0,3.94,2.61C136.87,131.41,141.64,138.1,139.85,141.58Z'
                style={{ fill: '#edeff4' }}
              />
              <path
                d='M166,112.15a29.67,29.67,0,0,1,2.32,8.17,16.88,16.88,0,0,1-.22,5.68,13.33,13.33,0,0,1-2.68,5.54,18.35,18.35,0,0,1-3.65,3.39,22,22,0,0,1-4.32,2.33,6.88,6.88,0,0,1-3.33-2.83c-1-2.1-.16-4.49.7-6.47a29.35,29.35,0,0,0,1.56-4.87c.48-1.92,2.34-3.06,3.38-4.67a16.85,16.85,0,0,0,2.48-6.37,4.16,4.16,0,0,1,.37-1.36,3.65,3.65,0,0,1,1-1,8.67,8.67,0,0,1,1-.7C165.07,110.05,165.55,111.11,166,112.15Z'
                style={{ fill: '#edeff4' }}
              />
              <path
                d='M176.46,117.12a18.16,18.16,0,0,1-3.05,4.78,1.89,1.89,0,0,1-1-1c-.27-.22-.55-.42-.8-.63a3.59,3.59,0,0,1-1.27-1.65s0,0,0-.06l0-.09c.33-.35.63-.72.93-1.1a16.92,16.92,0,0,0,1.43-2.2,4.15,4.15,0,0,0,.6.67c.55.28,1.13,0,1.71.09A2,2,0,0,1,176.46,117.12Z'
                style={{ fill: '#edeff4' }}
              />
              <path
                d='M177.67,113a16.31,16.31,0,0,1-.63,2.59,2.42,2.42,0,0,1-.83-.43c-.88-.6-2.2-.38-3-1.07a6.57,6.57,0,0,0,.26-.61,7.13,7.13,0,0,1,1.26-2.43,1.87,1.87,0,0,1,2.48-.32A2.5,2.5,0,0,1,177.67,113Z'
                style={{ fill: '#b4c2f1' }}
              />
              <path
                d='M172.25,123.1a17,17,0,0,1-4.15,2.9,16.88,16.88,0,0,0,.22-5.68,14.3,14.3,0,0,0,1.33-1.14,7.9,7.9,0,0,0,.65,1.53C170.92,121.63,171.77,122.36,172.25,123.1Z'
                style={{ fill: '#b4c2f1' }}
              />
              <path
                d='M142.09,94.16a1.56,1.56,0,0,0,.44.45c1.19.82,2.83.3,4-.22a10.43,10.43,0,0,0,3.65-2.26c2.62-2.84-.12-6.24-3-7.48a7.8,7.8,0,0,0-6.48.21,5.08,5.08,0,0,0-2,1.72c-1,1.55-.88,3.63,1,4.38a5.15,5.15,0,0,1,1.18.49C141.65,92.08,141.53,93.32,142.09,94.16Z'
                style={{ fill: '#b4c2f1' }}
              />
              <path
                d='M130.25,88.29a4.6,4.6,0,0,1-1.58.83c-2.57.93-4,1.71-5.37,4.12a12.73,12.73,0,0,0-2,4.8c-.12,1.34.26,2.87-.69,3.9a18.26,18.26,0,0,1-1.37-3.11c-.94-3.08-.75-6.27-1.09-9.43a11.75,11.75,0,0,1,.11-2.3c0-.52,0-1.11.09-1.62a.64.64,0,0,1,.22-.38c.34-.26.75,0,1,.24a51.86,51.86,0,0,1,4.44,4.2.75.75,0,0,0,1,.09,32.34,32.34,0,0,1,4-2.52c.47-.25,1-.5,1.44-.73a1.12,1.12,0,0,1,.19.29A1.49,1.49,0,0,1,130.25,88.29Z'
                style={{ fill: '#b4c2f1' }}
              />
              <path
                d='M133.37,87.73a2.64,2.64,0,0,0,.21,2.11,1.17,1.17,0,0,0,.61.57.6.6,0,0,0,.73-.27c.14-.32-.12-.68-.12-1,0-.63.82-1,1-1.55a1,1,0,0,0-.61-1.17,1.32,1.32,0,0,0-1.34.32,1.89,1.89,0,0,0-.52,1.32Z'
                style={{ fill: '#7b93e6' }}
              />
              <path
                d='M126.75,122.08c.06,1-.88,1.65-1.7,2.13a6.1,6.1,0,0,1-.72.37,45.79,45.79,0,0,1-1.48-9,3.62,3.62,0,0,0,.58.38,3.69,3.69,0,0,1,1,.62c.92.87.62,2.42,1.19,3.55C126,120.76,126.7,121.31,126.75,122.08Z'
                style={{ fill: '#b4c2f1' }}
              />
              <path
                d='M135.79,139.37a2.92,2.92,0,0,1,.61,1.58l-.75-.23a12.09,12.09,0,0,1-6.42-5.15,30.82,30.82,0,0,1-2.5-4.39c1.07-1.33,3.28-2.26,4.66-1.85s2,2.12,2,3.59-.13,3,.59,4.3A20.4,20.4,0,0,0,135.79,139.37Z'
                style={{ fill: '#b4c2f1' }}
              />
              <path
                d='M165.92,130.87c-.16.24-.33.46-.5.67a18.35,18.35,0,0,1-3.65,3.39,23.56,23.56,0,0,1-2.2,1.35,3.87,3.87,0,0,1-3.44-1c-.63-.74-1.32-3.2.21-3.31a5.23,5.23,0,0,1,1.24.18,4.78,4.78,0,0,0,3.65-1,8.77,8.77,0,0,0,2.4-3c.41-.8,1-1.38,1.94-1.14a1.64,1.64,0,0,1,1.13,1,2.07,2.07,0,0,1,0,1.49A6,6,0,0,1,165.92,130.87Z'
                style={{ fill: '#b4c2f1' }}
              />
              <path
                d='M166.22,112.69c-1.61,1.47-3.64,2.67-3.92,4.77-.17,1.32.32,3-.79,3.76a1.87,1.87,0,0,1-1.9,0,5.62,5.62,0,0,1-1.47-1.33c-1-1.13-2-2.56-1.54-4,.36-1.1,1.55-1.81,1.75-3,.14-.88-.36-1.79-.13-2.65.3-1.11,1.56-1.65,1.83-2.78.38-1.54-.71-3.12-.39-4.67a2.49,2.49,0,0,1,.51-1.06c.35.43.69.87,1,1.32.45.64.87,1.31,1.28,2,.76,1.26,1.45,2.58,2.1,3.91.51,1,1,2.11,1.44,3.15Z'
                style={{ fill: '#b4c2f1' }}
              />
              <path
                d='M177.23,110.42a2,2,0,0,0-2,0,4.35,4.35,0,0,0-1.73,2.47,17.22,17.22,0,0,1-2,3.87A16.72,16.72,0,0,1,170,118.5q-.44.45-.9.87c-.16.14-.36.38-.57.55a28.64,28.64,0,0,0-1.74-6.5,55.08,55.08,0,0,0-4.29-8.76,33.39,33.39,0,0,0-3-4,28.8,28.8,0,0,1-3-3.95c-1.85-3.18-2-7-3.5-10.33a37.81,37.81,0,0,0-5.52-8.52c-.52-.64-1.05-1.28-1.62-1.87a1.37,1.37,0,0,0-1.11-.57c-.75.08-.84,1-.85,1.59a41.53,41.53,0,0,1-.23,4.32c-.09.6-.11,1.42-.83,1.61a8.33,8.33,0,0,1-1.33.12c-.89.09-1.78.22-2.65.39a34.67,34.67,0,0,0-9.64,3.33c-.71.37-1.41.77-2.1,1.19-.34.2-.67.42-1,.64a7.11,7.11,0,0,1-1.23.85c-.8.27-1.81-1.22-2.3-1.71-.68-.68-1.38-1.35-2.12-2-.55-.48-1.8-1.66-2.31-.47a7.24,7.24,0,0,0-.18,2.08,13.39,13.39,0,0,0,0,2.37c.31,3.39.11,7,1.42,10.18.66,1.62,1.64,3.1,2.28,4.73a15.62,15.62,0,0,1,.86,5.42,71.06,71.06,0,0,0,.62,10.1,43.68,43.68,0,0,0,2.69,9.59,27.45,27.45,0,0,0,4.72,7.91,12.9,12.9,0,0,0,7.24,3.88,21.28,21.28,0,0,0,9.62-.38,50.25,50.25,0,0,0,5.09-1.78c1.65-.65,3.34-1.19,5-1.85a22.54,22.54,0,0,0,4.43-2.39,16.1,16.1,0,0,0,5.69-6.74,12.74,12.74,0,0,0,.71-2.22,18.36,18.36,0,0,0,8.72-9.78,17,17,0,0,0,.87-3.22C178,112.24,178.11,111,177.23,110.42Zm-11.92,20.87a18,18,0,0,1-3.69,3.44c-2.85,2-6.1,2.92-9.29,4.18a30.09,30.09,0,0,1-9.76,2.5,16.77,16.77,0,0,1-9.15-2c-2.47-1.49-4.15-4-5.52-6.47a41.75,41.75,0,0,1-4.86-18.4c-.12-3.16.29-6.48-.73-9.53a38.21,38.21,0,0,0-2-4.34,15.82,15.82,0,0,1-1.41-5.09c-.18-1.57-.21-3.16-.32-4.73a18.58,18.58,0,0,1-.13-2.58c0-.38.08-.76.11-1.14,0-.54-.18-1.22.11-1.71a.45.45,0,0,1,.45-.24c.17,0,.27.2.39.31l.49.41.92.8c.64.59,1.25,1.19,1.86,1.81.86.85,1.5,2,2.71,1.12a36.55,36.55,0,0,1,8.93-4.56,34,34,0,0,1,5-1.27c.79-.13,1.57-.24,2.36-.32a4.26,4.26,0,0,0,1.85-.28,1.66,1.66,0,0,0,.52-1.24c.13-.83.22-1.67.28-2.51,0-.61.06-1.22,0-1.83a4,4,0,0,1,.07-1.34c.4-1.09,1.49.47,1.87.91.55.63,1.08,1.28,1.59,1.94a48.45,48.45,0,0,1,2.8,4,24.33,24.33,0,0,1,2.37,4.73c.52,1.51.87,3.07,1.29,4.6A18.41,18.41,0,0,0,156.12,97a26.92,26.92,0,0,0,2.83,3.73,38.86,38.86,0,0,1,5.3,8.22,46.4,46.4,0,0,1,3.08,7.69C168.72,121.57,168.66,127.08,165.31,131.29Zm12-17.73a17.76,17.76,0,0,1-8.89,12,17.19,17.19,0,0,0,.21-4.53l-.06-.57a7.27,7.27,0,0,0,1.09-1,17,17,0,0,0,1.31-1.37,16.23,16.23,0,0,0,2.08-3.11c.62-1.19.9-2.86,1.88-3.81.58-.56,1.68-.9,2.26-.14S177.47,112.79,177.32,113.56Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M148.44,82.35c.05.14.1.28.14.42a.39.39,0,0,1-.05.43c-.1.08-.26,0-.38,0a5,5,0,0,0-2-.29.84.84,0,0,1-.39-.05c-.42-.22-.21-1.36-.21-1.74l0-2.23c0-.17,0-.38.18-.44s.34.09.45.23A13.89,13.89,0,0,1,148.44,82.35Z'
                style={{ fill: '#606060' }}
              />
              <path
                d='M120.16,92.51c0,.15.11.29.16.43s.16.3.31.29.22-.14.29-.25a5.2,5.2,0,0,1,1.35-1.49.69.69,0,0,0,.27-.29c.19-.44-.7-1.17-1-1.47L120.19,88c-.11-.13-.26-.28-.42-.23s-.2.28-.2.46A13.83,13.83,0,0,0,120.16,92.51Z'
                style={{ fill: '#606060' }}
              />
              <path
                d='M138.61,96.44a1.72,1.72,0,0,1-2.53,1,3.19,3.19,0,0,0,.86-1.89A3.12,3.12,0,0,0,138.61,96.44Z'
                style={{ fill: '#ef4738' }}
              />
              <path
                d='M138.58,96.12a.24.24,0,0,0-.25.2,1.32,1.32,0,0,1-.82,1.06,1.35,1.35,0,0,1-1.32-.22.22.22,0,1,0-.29.34,1.8,1.8,0,0,0,1.74.32l0,0a1.78,1.78,0,0,0,1.1-1.43A.22.22,0,0,0,138.58,96.12Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M133.21,97.06a2,2,0,0,0,3.33-1.92c0-.21.31-.34.41-.15a2,2,0,0,0,3.8-.64c0-.29.48-.2.44.08A2.46,2.46,0,0,1,137,95.87a2.46,2.46,0,0,1-4.12,1.54C132.7,97.21,133,96.87,133.21,97.06Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M136.94,95.14l1.3-2.56a.22.22,0,0,0-.27-.31L134,93.69a.21.21,0,0,0,0,.4l2.64,1.16A.23.23,0,0,0,136.94,95.14Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M146.73,90.76l1.43-1.44c.21-.2.56.09.35.29l-1.43,1.44C146.88,91.25,146.53,91,146.73,90.76Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M147.39,91.63a16.38,16.38,0,0,0,1.91-.86c.26-.14.52.23.27.37a16.83,16.83,0,0,1-2,.92C147.27,92.16,147.12,91.74,147.39,91.63Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M147.84,92.39a9.08,9.08,0,0,1,2.27.11.22.22,0,0,1-.08.44,9.12,9.12,0,0,0-2.15-.1A.23.23,0,0,1,147.84,92.39Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M124.31,98.28c-.29,0-.21-.48.08-.45q1.06.09,2.13.27a.22.22,0,0,1-.08.44C125.73,98.43,125,98.34,124.31,98.28Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M124.25,99.73l2.19-.57c.28-.08.44.35.15.42l-2.19.57C124.12,100.23,124,99.8,124.25,99.73Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M125,101.44l1.59-1.41c.22-.2.48.18.27.37l-1.6,1.41C125,102,124.73,101.64,125,101.44Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M143.37,88.65a1.61,1.61,0,0,0-1.75.56,2.52,2.52,0,0,0-.23,1.86.22.22,0,0,0,.25.19h.05a.23.23,0,0,0,.14-.24,2.23,2.23,0,0,1,.16-1.54,1.15,1.15,0,0,1,1.25-.39,1.71,1.71,0,0,1,1,1,.23.23,0,1,0,.42-.18A2.19,2.19,0,0,0,143.37,88.65Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M129.26,93.65a1.61,1.61,0,0,0-1.7.68,2.17,2.17,0,0,0-.24,1.81.22.22,0,0,0,.28.15.23.23,0,0,0,.16-.28,1.69,1.69,0,0,1,.17-1.42,1.15,1.15,0,0,1,1.21-.5c.47.13.79.59,1.1,1.09a.24.24,0,0,0,.27.09l0,0a.22.22,0,0,0,.07-.31A2.52,2.52,0,0,0,129.26,93.65Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M139.53,133a5.44,5.44,0,0,0-1.18-1.44,1.91,1.91,0,0,0-1.93-.23,1.67,1.67,0,0,0-.84,1.59,4.09,4.09,0,0,0,.65,1.66c1.21,2.14,2.53,4.38,4.85,5.56l4.67-1.79A15.9,15.9,0,0,1,139.53,133Z'
                style={{ fill: '#fffefd' }}
              />
              <path
                d='M136.91,133.7a.87.87,0,0,1,.65-.6.72.72,0,0,1,.72-.06h0l.06,0a.46.46,0,0,1,.13.59,1.11,1.11,0,0,1-.48.43,1,1,0,0,1-.7.15A.49.49,0,0,1,136.91,133.7Z'
                style={{ fill: '#fdb2a8' }}
              />
              <path
                d='M138,132.19a.26.26,0,0,1,.18.49.26.26,0,0,1-.33-.16A.27.27,0,0,1,138,132.19Z'
                style={{ fill: '#fdb2a8' }}
              />
              <path
                d='M136.47,133a.27.27,0,0,1,.33.16.26.26,0,0,1-.16.33.26.26,0,0,1-.33-.16A.26.26,0,0,1,136.47,133Z'
                style={{ fill: '#fdb2a8' }}
              />
              <path
                d='M137.28,131.93a.3.3,0,0,1,.36.17.28.28,0,0,1-.17.36.28.28,0,0,1-.36-.17A.3.3,0,0,1,137.28,131.93Z'
                style={{ fill: '#fdb2a8' }}
              />
              <path
                d='M136.43,132.56c0-.17.13-.38.32-.33h0a.28.28,0,0,1,.21.21.26.26,0,0,1-.11.27h0A.29.29,0,0,1,136.43,132.56Z'
                style={{ fill: '#fdb2a8' }}
              />
              <path
                d='M145.85,138.11a16,16,0,0,1-5.66-4.63c-.88-1.17-2.17-3.47-4-2.31s-.28,3.38.48,4.64a11.52,11.52,0,0,0,4.31,4.53c.27.15.48-.29.2-.44a10.5,10.5,0,0,1-3.84-3.93,12.61,12.61,0,0,1-1.35-2.43c-.49-1.38.61-2.71,2-1.9.8.45,1.22,1.41,1.76,2.12a16.47,16.47,0,0,0,1.61,1.83,16.89,16.89,0,0,0,4.25,3C145.93,138.7,146.13,138.25,145.85,138.11Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M162.28,125.19c0,.25.09.51.13.76a11.67,11.67,0,0,1-.33,6.62l-4.74,1.6a16.09,16.09,0,0,0,1.45-6.32,15,15,0,0,0-.07-1.77,5.34,5.34,0,0,1,0-1.87,1.9,1.9,0,0,1,1.34-1.4,1.67,1.67,0,0,1,1.66.7A3.89,3.89,0,0,1,162.28,125.19Z'
                style={{ fill: '#fffefd' }}
              />
              <path
                d='M162.41,126a16.76,16.76,0,0,1,.28,4.06c-.09,1.13-.32,2.75-1.33,3.45a5,5,0,0,1-1.06.53l-1.34.53a2,2,0,0,1-1,.21c-.87-.09-.58-.75-.37-1.27a16.68,16.68,0,0,0,.61-1.85,20.23,20.23,0,0,0,.54-3.76,3.31,3.31,0,0,0,1.64-.16A6.3,6.3,0,0,0,162.41,126Z'
                style={{ fill: '#b4c2f1' }}
              />
              <path
                d='M161.21,125a.9.9,0,0,0-.89,0,.72.72,0,0,0-.59.41h0a.14.14,0,0,0,0,.07.46.46,0,0,0,.27.54,1.19,1.19,0,0,0,.65,0,1,1,0,0,0,.63-.33A.49.49,0,0,0,161.21,125Z'
                style={{ fill: '#fdb2a8' }}
              />
              <path
                d='M159.39,124.5a.27.27,0,0,0-.15.33.26.26,0,0,0,.33.16.25.25,0,0,0,.15-.33A.26.26,0,0,0,159.39,124.5Z'
                style={{ fill: '#fdb2a8' }}
              />
              <path
                d='M161.11,124.16a.26.26,0,0,0-.15.33.27.27,0,0,0,.33.16.25.25,0,0,0,.15-.33A.26.26,0,0,0,161.11,124.16Z'
                style={{ fill: '#fdb2a8' }}
              />
              <path
                d='M159.79,123.84a.28.28,0,0,0-.17.36.29.29,0,0,0,.36.17.28.28,0,0,0,.17-.36A.29.29,0,0,0,159.79,123.84Z'
                style={{ fill: '#fdb2a8' }}
              />
              <path
                d='M160.84,123.78a.28.28,0,0,0-.45,0v0a.28.28,0,0,0,0,.29.26.26,0,0,0,.26.14h0A.27.27,0,0,0,160.84,123.78Z'
                style={{ fill: '#fdb2a8' }}
              />
              <path
                d='M160.15,122.56c-2.15.27-1.68,2.86-1.61,4.32a16,16,0,0,1-1.42,7.18.24.24,0,0,0,.44.21,17,17,0,0,0,1.38-5A14.7,14.7,0,0,0,159,127a7.26,7.26,0,0,1,0-2.9,1.43,1.43,0,0,1,2.74,0,12.65,12.65,0,0,1,.55,2.88,10.53,10.53,0,0,1-.46,5.48c-.12.29.32.5.44.21a11.61,11.61,0,0,0,.43-6.24C162.51,125,162.26,122.29,160.15,122.56Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M136,119.78c-.18.62-.95.84-1.6.87a8.1,8.1,0,0,1-2.41-.24,9.23,9.23,0,0,1-1.61-.54,12.38,12.38,0,0,1-3-1.85c-.25-.21-.49-.43-.72-.65l2.29-3.62a23.49,23.49,0,0,0,3,2.57,23.89,23.89,0,0,0,2.65,1.64,3.81,3.81,0,0,1,1,.68A1.21,1.21,0,0,1,136,119.78Z'
                style={{ fill: '#fffefd' }}
              />
              <path
                d='M136,119.78c-.18.62-.95.84-1.6.87a8.1,8.1,0,0,1-2.41-.24,8.71,8.71,0,0,1,0-4.09,23.89,23.89,0,0,0,2.65,1.64,3.81,3.81,0,0,1,1,.68A1.21,1.21,0,0,1,136,119.78Z'
                style={{ fill: '#edeff4' }}
              />
              <path
                d='M130.3,117.28c-.06,1-.34,1.34-.07,2.31a1.57,1.57,0,0,0,.1.28,12.38,12.38,0,0,1-3-1.85c.19-1,.8-2.17,1.81-2.07A1.3,1.3,0,0,1,130.3,117.28Z'
                style={{ fill: '#b4c2f1' }}
              />
              <path
                d='M134.41,117.6a22.6,22.6,0,0,1-5.33-4c-.22-.23-.53.15-.31.37a22.52,22.52,0,0,0,3.57,3A19.61,19.61,0,0,0,134.2,118c.24.14.51.26.76.41a7.6,7.6,0,0,1-1.17-.25c-.3-.09-.38.39-.09.48a7.78,7.78,0,0,0,1.85.31l0,.56a5.55,5.55,0,0,1-1.62-.51.24.24,0,0,0-.21.44,6,6,0,0,0,1.79.56v0a1.13,1.13,0,0,1-.62.26,9.47,9.47,0,0,1-1.6-.78c-.27-.16-.47.28-.21.44a8.52,8.52,0,0,0,.84.46c-2.61.08-5.29-1.58-7.08-3.28-.23-.21-.54.16-.32.38a12.5,12.5,0,0,0,4.63,2.86c1.25.42,3.34.92,4.55.11a1.2,1.2,0,0,0,.5-1.44C135.88,118.3,135.08,118,134.41,117.6Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M158.72,105.83a6.61,6.61,0,0,1-.48,2.35,11.34,11.34,0,0,1-1.43,3,8.54,8.54,0,0,1-1.94,2c-.52.39-1.26.72-1.8.35a1.2,1.2,0,0,1-.44-1.11,3.73,3.73,0,0,1,.37-1.19,25.06,25.06,0,0,0,.84-2.39,22.44,22.44,0,0,0,.62-2.79c0-.32.09-.63.13-1a5.85,5.85,0,0,1,0-.73c.13-.49.86-.67,1.29-.64a4,4,0,0,1,1.5.52,3.33,3.33,0,0,1,.89.58A1.4,1.4,0,0,1,158.72,105.83Z'
                style={{ fill: '#fffefd' }}
              />
              <path
                d='M158.21,108.18a2.16,2.16,0,0,1-.19.66,11.18,11.18,0,0,1-1.21,2.39c-.07-.1-.14-.2-.2-.3-.41-.68-.43-1.52-1.22-1.63a5.48,5.48,0,0,1-1.55-.37s.51-2.23.56-2.42c.17-.62,1-.76,1.6-.62a2.92,2.92,0,0,1,1.27.84,3.57,3.57,0,0,1,.82,1A1,1,0,0,1,158.21,108.18Z'
                style={{ fill: '#b4c2f1' }}
              />
              <path
                d='M158.49,105.78c-.3,2.45-1.31,5.44-3.38,7a6.77,6.77,0,0,0,.36-.88c.1-.29-.34-.5-.44-.2a10.75,10.75,0,0,1-.74,1.62,1.18,1.18,0,0,1-.47.15.36.36,0,0,1-.17,0,5.65,5.65,0,0,0,1-1.52.24.24,0,0,0-.44-.21,5.64,5.64,0,0,1-.95,1.46,1.31,1.31,0,0,1-.31-.49,7.75,7.75,0,0,0,1.18-1.37c.17-.26-.2-.57-.37-.31a8.59,8.59,0,0,1-.75.94c.08-.23.19-.46.28-.67.27-.68.52-1.36.73-2a23.6,23.6,0,0,0,.9-4.71c0-.31-.45-.4-.48-.09a22.74,22.74,0,0,1-1.54,6.51,3.31,3.31,0,0,0-.44,2.14,1.23,1.23,0,0,0,1.34.91c1.46-.15,2.74-1.86,3.45-3a12.75,12.75,0,0,0,1.74-5.16C159,105.56,158.53,105.47,158.49,105.78Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M153.18,91.77a15.42,15.42,0,0,1-8,3.21c-.47,0-.42.78.05.73a16.12,16.12,0,0,0,8.33-3.35C154,92.08,153.55,91.48,153.18,91.77Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M145.23,94.79c.43.44-.2,1.33-.8,1.17a.66.66,0,0,1-.46-.48.73.73,0,0,1,.45-.8.74.74,0,0,1,.68,0Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M150,75a18,18,0,0,0-6.49-2.86c-.6-.14-1.21-.26-1.82-.35a28.38,28.38,0,0,0-13.94,1.67,26.56,26.56,0,0,0-9.49,6.25c-.45.47-.88,1-1.29,1.48a19.09,19.09,0,0,0-3.81,7.92,17.59,17.59,0,0,0,9.42,18.67c4.51,2.3,9.68.94,14.26-.54a88.27,88.27,0,0,0,11.27-4.51c1.63-.78,4.09-1.58,5.4-2.84a11,11,0,0,0,2.36-3.82C158.28,88.76,156.54,79.67,150,75Zm-.28,20.3a33.85,33.85,0,0,1-21.36,8.55,15.37,15.37,0,0,1-6.29-.9c-1.07-.44-2.61-1.13-3-2.29a8.89,8.89,0,0,1,.09-4.07,18.57,18.57,0,0,1,3.4-7c.19-.26.38-.51.58-.75a18.82,18.82,0,0,1,1.24-1.44A20.45,20.45,0,0,1,133,81.88a20.09,20.09,0,0,1,8.08-.84h0q.88.09,1.74.24a19.92,19.92,0,0,1,2.4.57c2.79.83,6,2.05,8,4.28l.21.26C155.83,89.53,152.12,93.17,149.76,95.29Z'
                style={{ fill: '#f2f2f2' }}
              />
              <g style={{ opacity: 0.85 }}>
                <path
                  d='M123,89.27a18.82,18.82,0,0,0-1.24,1.44,30.75,30.75,0,0,1-3.79-4,29.51,29.51,0,0,1-2.42-3.58c.41-.51.84-1,1.3-1.48a30.46,30.46,0,0,0,2.53,3.89A26.29,26.29,0,0,0,123,89.27Z'
                  style={{ fill: '#fbb03b' }}
                />
                <path
                  d='M144.63,72.21c.05,1.08.05,2.15,0,3.22a37.83,37.83,0,0,1-.75,5.94c-.58-.11-1.16-.18-1.74-.24a33,33,0,0,0,.7-5.84c0-1.14,0-2.28,0-3.42C143.42,72,144,72.07,144.63,72.21Z'
                  style={{ fill: '#fbb03b' }}
                />
              </g>
              <path
                d='M155.52,81.64a16.22,16.22,0,0,0-6.08-7.2,19.77,19.77,0,0,0-8.57-2.86,28.42,28.42,0,0,0-17.63,4c-5.38,3.29-9.91,8.77-10.52,15.23a18,18,0,0,0,3,11.3,17.09,17.09,0,0,0,3.83,4.13,19.46,19.46,0,0,0,2.3,1.52,22.29,22.29,0,0,0,3,1.16c.29.11.49-.33.2-.44-.75-.3-1.55-.45-2.28-.8a15.87,15.87,0,0,1-2.37-1.43,16.84,16.84,0,0,1-3.64-3.56A17.89,17.89,0,0,1,113.16,93c-.33-6.47,3.69-12.36,8.78-16,9.18-6.56,25.55-8.12,32.16,2.89a19.28,19.28,0,0,1,2.59,10,21.38,21.38,0,0,1-.7,5.22,8.31,8.31,0,0,1-1.17,2.63c-.47.69-1,1.34-1.4,2.06-.16.27.28.48.44.21.83-1.45,2-2.6,2.44-4.23a20.82,20.82,0,0,0,.83-4.77A20.39,20.39,0,0,0,155.52,81.64Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M153.63,86.41c-1.82-2.29-4.72-3.49-7.42-4.36a22.52,22.52,0,0,0-9.6-1c-6.63.79-12.15,5-15.53,10.63-1.5,2.49-2.87,5.87-2.26,8.84a3.92,3.92,0,0,0,2.55,2.57,13.33,13.33,0,0,0,4.48,1.14,32.84,32.84,0,0,0,19.36-5,29.47,29.47,0,0,0,7.39-6.23C154.13,91,155.23,88.59,153.63,86.41Zm-7.14,11.32a33.69,33.69,0,0,1-17.53,6,19.82,19.82,0,0,1-4.68-.24,9.49,9.49,0,0,1-4.16-1.75c-1.26-1.08-1-3-.72-4.47A15.09,15.09,0,0,1,120.85,93a21.3,21.3,0,0,1,13.82-11.2,20.89,20.89,0,0,1,10.24.34c3,.84,6.34,2,8.32,4.53,1.49,2,.35,4.28-1.07,6A28.11,28.11,0,0,1,146.49,97.73Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M157.39,97.65c.07-.43-.47-.86-.63-1.25-.1-.22-.16-.45-.44-.51s-.79.5-1.06.73a49.47,49.47,0,0,1-19.75,10.1,40.76,40.76,0,0,1-6.84,1.09c-1.14.08-2.29.11-3.43.08-.52,0-2.88-.46-3.11,0a.82.82,0,0,0,0,.41c0,.79-.4,1.65.58,1.79a16.62,16.62,0,0,0,2.82.08,51.76,51.76,0,0,0,23.26-6.5,54,54,0,0,0,4.95-3.1c.8-.57,1.58-1.15,2.34-1.76.4-.31,1.19-.62,1.35-1.15C157.39,97.68,157.39,97.67,157.39,97.65Z'
                style={{ fill: 'gray' }}
              />
              <path
                d='M157.1,96.51c-.2-.32-.28-.75-.71-.85a1,1,0,0,0-.87.35c-.51.46-1,.92-1.55,1.35a50.65,50.65,0,0,1-7.75,5,45,45,0,0,1-18,5.21,21.57,21.57,0,0,1-3.77,0,4.68,4.68,0,0,0-2.17,0,.59.59,0,0,0-.37.43,4.25,4.25,0,0,0-.1,1.51c.1,1,1.25.94,2,1a47.4,47.4,0,0,0,17.78-3.2,53.7,53.7,0,0,0,9.16-4.43A50.93,50.93,0,0,0,155,99.93c.6-.45,1.2-.9,1.83-1.32a1.66,1.66,0,0,0,.78-.91.24.24,0,0,0,0-.12A2.45,2.45,0,0,0,157.1,96.51ZM156,98.59c-.54.38-1.05.82-1.59,1.21-1.06.78-2.15,1.52-3.26,2.22a53.17,53.17,0,0,1-7.33,3.83,51.49,51.49,0,0,1-15.62,3.94,37.67,37.67,0,0,1-4,.18c-.7,0-1.83.12-1.94-.78a3,3,0,0,1,0-.66c0-.33,0-.47.32-.58a6.32,6.32,0,0,1,2.28.16,20.7,20.7,0,0,0,3.15,0,44.14,44.14,0,0,0,15.15-3.73,50.23,50.23,0,0,0,7.66-4.16c1.2-.8,2.37-1.64,3.5-2.54a16.25,16.25,0,0,0,1.34-1.15c.38-.38.65-.13.94.2a2,2,0,0,1,.49.93C157,98.08,156.31,98.35,156,98.59Z'
                style={{ opacity: 0.85, fill: '#fbb03b' }}
              />
              <path
                d='M133.61,78a2,2,0,0,1-3.4.1c-.66-1.27.42-2.31,1.68-2.66.26-.08.15-.42-.09-.42a2.36,2.36,0,0,0-2,3.53,2.55,2.55,0,0,0,4.27-.33C134.28,77.89,133.79,77.68,133.61,78Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M128,79.35l1.34-.64c.26-.12.12-.56-.15-.43l-1.34.64c-.26.12-.12.56.15.43Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M123.59,84.21a1.9,1.9,0,0,1-3.44,0c-.72-1.42.34-2.53,1.6-2.87.26-.07.13-.45-.1-.46-1.87-.07-2.81,2.3-1.87,3.81a2.46,2.46,0,0,0,4.32-.21A.28.28,0,0,0,123.59,84.21Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M136.6,75c-.31-.38-.77-1-1.36-.92s-.53.82-.52,1.28c0,1.15,0,2.31.12,3.46,0,.24.44.26.44,0,0-.53,0-1.07,0-1.6l1-.35a7,7,0,0,0,.8-.31c.27.42.52.84.77,1.26.16.25.59,0,.45-.25A13.31,13.31,0,0,0,136.6,75Zm-.52,1.36-.81.3,0-.73c0-.2-.12-.82,0-.94.52-.63,1.28.75,1.5,1.06l0,0A7,7,0,0,0,136.08,76.34Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M141.59,73.54a19.33,19.33,0,0,0-3.73.36.19.19,0,0,0,0,.37,7.66,7.66,0,0,0,1.59,0c.09,1.17.24,2.33.35,3.49,0,.35.59.32.54,0-.14-1.16-.24-2.34-.41-3.5.56,0,1.13-.13,1.67-.16C142,74.06,141.94,73.51,141.59,73.54Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M125.62,83.08a31.5,31.5,0,0,0-2.08-3.42l-.29.33c1.22.8,2,2.11,3.31,2.78a.24.24,0,0,0,.33-.22q-.3-2.26-.63-4.53l-.38.19c1.1.86,1.43,2.3,2.21,3.41a.23.23,0,0,0,.38-.26c-.81-1.14-1.15-2.6-2.29-3.5-.14-.11-.41,0-.38.19.22,1.51.43,3,.63,4.52l.33-.21c-1.31-.66-2.09-2-3.3-2.77-.2-.13-.42.15-.3.33a29.69,29.69,0,0,1,2.08,3.42c.14.26.52,0,.38-.26Z'
                style={{ fill: '#1a1a1a' }}
              />
              <path
                d='M120.44,96.13a7,7,0,0,1,1.13-3.64,8,8,0,0,1,2.49-3,.66.66,0,0,1,.91.93,31.66,31.66,0,0,0-2.1,2.75c-.54,1-.82,2.08-1.32,3.09C121.31,96.78,120.45,96.75,120.44,96.13Z'
                style={{ fill: '#fffefd' }}
              />
              <path
                d='M125.64,87.49a1.78,1.78,0,0,1,1.06-.79c.4,0,.88.3.78.74a1.36,1.36,0,0,1-.45.74,2.48,2.48,0,0,1-.52.38.71.71,0,0,1-.84-.2A.74.74,0,0,1,125.64,87.49Z'
                style={{ fill: '#fffefd' }}
              />
            </g>
          </svg>
          <Quote className={highlight ? 'highlight' : undefined}>{quote}</Quote>
          <Description className={highlight ? 'highlight' : undefined}>
            {(linkto ? <DescriptionLink to={linkto}>{description}</DescriptionLink> : description)}
          </Description>
        </VBox>
      </Centered>
    )
  }
}

EmptyState.defaultProps = {
  quote: 'The data is lost in space...',
  description: 'There are no results',
  viewBox: '0 50 294.53 100.79',
  height: '100px'
}

export default EmptyState
